import Head from 'next/head';
import React, { ReactNode } from 'react';
import { Thing } from 'schema-dts';

import { TemplateSetting } from '@/lib/types';

import { HtmlScript } from '@/components/renderers/script';

import { SeoProps } from '@/hygraph/transformers/seo.transformer';
import {
  INITIAL_PAGE_STATIC_DATA_PROPS,
  PageStaticDataProps,
} from '@/services/page-static-data.service';

export type PageMetaProps = SeoProps & {
  navigationLabel?: string;
  templateSetting?: TemplateSetting;
  canonicalLink?: string | null;
};

export interface IGlobalContextProps {
  children?: ReactNode | undefined;
  pageMeta: PageMetaProps;
  schema?: Thing[];
  pageStaticData?: Partial<PageStaticDataProps>;
}

export const GlobalContext = React.createContext<IGlobalContextProps>({
  pageMeta: {
    keywords: [],
    noIndex: false,
    canonicalLink: null,
  },
  schema: [],
  pageStaticData: INITIAL_PAGE_STATIC_DATA_PROPS,
});

export function GlobalContextProvider(props: IGlobalContextProps) {
  const schema = JSON.stringify(props.schema || []);
  const canonicalLink = props.pageMeta.canonicalLink || null;

  return (
    <GlobalContext.Provider value={props}>
      {canonicalLink && (
        <Head>
          <link type='canonical' href={canonicalLink} />
        </Head>
      )}
      <HtmlScript id='schema' type='application/ld+json' html={schema} />
      {props.children}
    </GlobalContext.Provider>
  );
}
